import React from 'react'
import PropTypes from 'prop-types'

class WelcomePage extends React.Component {

  componentDidMount() {
    setTimeout( () => {
      window.location.href = '/'
    }, 3000 )
  }

  render() {
    const { assets_path } = this.props
    
    return (
      <>
        <div 
          className="fixed inset-0 -z-10 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(/${assets_path}/images/welcome_bg.svg)`
          }}
        />
        <div className="container font-inter relative min-h-screen">
          <div className="min-h-screen flex flex-col items-center justify-center py-8">
            <img
              src={`/${assets_path}/images/start_logo.svg`}
              width={225}
              height={92}
              alt="okidoki"
            />
            <div className="mt-[4px] text-center">
              <span className="text-[22px] text-white font-gilroy">
                Спасибо за заказ!
              </span>
            </div>
          </div>
        </div>
      </>
    )
  }
}

WelcomePage.propTypes = {
  assets_path: PropTypes.string
}

export default WelcomePage